const defaults = new Map()
import { VueComponentUpload as upload } from '@kvass/storage'
// placemnet : residential:basis
//placement residential-templates
defaults.set('basis-residential-template', ctx => {
  return {
    key: 'basis-residential-template',
    label: ctx.$t('basis'),
    placement: 'residential-template:basis',
    component: [
      {
        key: 'name',
        label: ctx.$t('name'),
        component: 'Input',
        options: {
          validation: `required`,
        },
      },
      {
        key: 'showInternalName',
        label: ctx.$t('useInternalName'),
        component: 'Checkbox',
      },
      {
        key: 'internalName',
        label: ctx.$t('internalName'),
        component: 'Input',
      },
      {
        key: 'price',
        label: ctx.$t('price'),
        component: 'Number',
      },
    ],
    options: {
      collapsible: true,
      expanded: true,
      size: 2,
      condition: {
        internalName: {
          'basis-residential-template.showInternalName': true,
        },
      },
      layout: 'name internalName | showInternalName showInternalName  | price price',

      props: {
        _parent: {
          sublabel: ctx.$t('residentialSublabelBasis'),
        },

        price: {
          align: 'right',
          mask: {
            mask: Number,
            unmask: true,
            thousandsSeparator: ' ',
          },
          suffix: ctx.$path('$store.state.enums.Region.currency', ctx),
        },

        internalName: {
          style: 'flex-grow:0 !important;',
        },
        showInternalName: {
          style: 'margin-top: -0.5rem;',
        },
      },
    },
  }
})

defaults.set('basis-owners', ctx => {
  return {
    key: 'owners',
    label: ctx.$tc('owner', 2),
    placement: 'residential:basis',
    component: [
      {
        key: 'owners',
        label: 'owner',
        component: 'Slot',
      },
    ],
    options: {
      collapsible: true,
      size: 2,
      layout: 'owners',

      condition: {
        owners: {
          'ownerReservedState.key': 'owners',
        },
      },
      props: {
        _parent: {
          sublabel: ctx.$t('informationAboutX', { x: ctx.$tc('owner', 2) }),
          disabled: true,
        },
      },
    },
  }
})

defaults.set('basis-reservedBy', ctx => {
  return {
    key: 'reservedBy',
    label: ctx.$t('reservedBy'),
    placement: 'residential:basis',
    component: [
      {
        key: 'reservedBy',
        label: 'reservedBy',
        component: 'Slot',
      },
    ],
    options: {
      collapsible: true,
      size: 2,
      layout: 'reservedBy',
      condition: {
        reservedBy: {
          'ownerReservedState.key': 'reservedBy',
        },
      },
      props: {
        _parent: {
          sublabel: ctx.$t('informationAboutX', { x: ctx.$t('reservedBy').toLowerCase() }),
        },
      },
    },
  }
})

defaults.set('basis-residential', ctx => {
  return {
    key: 'basis-residential',
    label: ctx.$t('basis'),
    placement: ['residential:basis', 'residential-update:basis'],
    component: [
      {
        key: 'number',
        label: ctx.$t('unitNumber'),
        component: 'Number',
        options: {
          validation: `residentialNumber:${ctx.$path('item.project.id')},${ctx.$path('item.number')}|required|min:1`,
        },
      },
      {
        key: 'showDisplayName',
        label: ctx.$t('useDisplayName'),
        component: 'Checkbox',
      },
      {
        key: 'displayName',
        label: ctx.$t('displayName'),
        component: 'Input',
      },
      {
        key: 'sale-type',
        label: ctx.$t('saleType'),
        component: 'Radio',
        dataKey: 'sale.type',
      },
      {
        key: 'status',
        label: ctx.$t('status'),
        component: 'Slot',
      },
      {
        key: 'sale',
        label: ctx.$t('sale'),
        component: 'Slot',
      },
    ],
    options: {
      collapsible: true,
      expanded: true,
      size: 2,
      condition: {
        displayName: {
          'basis-residential.showDisplayName': true,
        },
      },
      layout: 'number displayName | showDisplayName showDisplayName | sale-type status | sale sale',

      props: {
        _parent: {
          sublabel: ctx.$t('residentialSublabelBasis'),
        },
        'sale-type': {
          items: ctx.$store.state.enums.ResidentialSaleType.map(value => ({ value, label: ctx.$t(value) })),
        },
        displayName: {
          style: 'flex-grow:0 !important;',
        },
        showDisplayName: {
          style: 'margin-top: -0.5rem;',
        },
        number: {
          mask: ctx.pattern
            ? { mask: ctx.pattern, unmask: true }
            : { mask: Number, unmask: true, thousandsSeparator: ' ' },
        },
      },
    },
  }
})

defaults.set('residential-update-sale', ctx => {
  return {
    key: 'residential-update-sale',
    label: ctx.$t('sale'),
    placement: ['residential-update:sale'],
    component: [
      {
        key: 'value',
        label: ctx.$t('price'),
        component: 'Number',
      },
      {
        key: 'fixed',
        label: ctx.$t('residentialSaleFixed'),
        component: 'Checkbox',
      },
      {
        key: 'fee',
        label: ctx.$t('residentialSaleFee'),
        component: [
          {
            key: 'value',
            label: '',
            component: 'Number',
          },
          {
            key: 'included',
            label: ctx.$t('residentialSaleFeeIncluded'),
            component: 'Checkbox',
          },
        ],
        options: {
          layout: 'value | included',
          props: {
            value: {
              suffix: ctx.$path('$store.state.enums.Region.currency', ctx),
            },
          },
        },
      },
      {
        key: 'jointDebtInterestRate',
        label: ctx.$t('jointDebtInterestRate'),
        component: 'Number',
      },
      {
        key: 'jointDebt',
        label: ctx.$t('jointDebt'),
        component: 'Number',
      },
      {
        key: 'deposit',
        label: ctx.$t('deposit'),
        component: 'Number',
      },
    ],
    options: {
      collapsible: true,
      size: 2,

      props: {
        jointDebtInterestRate: {
          suffix: '%',
          max: '100',
        },
        deposit: {
          suffix: ctx.$path('$store.state.enums.Region.currency', ctx),
        },
        jointDebt: {
          suffix: ctx.$path('$store.state.enums.Region.currency', ctx),
        },
        value: {
          suffix: `${ctx.$path('$store.state.enums.Region.currency', ctx)} ${
            (ctx.saleTypes || []).includes('rent') ? `/ ${ctx.$t('multiplicatorMonthly')}` : ''
          }`,
        },
      },
    },
  }
})
defaults.set('basis-address', ctx => {
  return {
    key: 'basis-address',
    label: ctx.$t('addressForUnit'),
    placement: 'residential:basis',
    component: [
      {
        key: 'address',
        label: 'address',
        component: 'Slot',
      },
      {
        key: 'cadastre',
        label: ctx.$t('cadastre'),
        component: 'Input',
        options: {
          validation: `cadastre:${ctx.$path('item.cadastre')}`,
        },
      },
    ],

    options: {
      collapsible: true,
      size: 2,
      layout: 'address | cadastre',
      props: {
        _parent: {
          sublabel: ctx.$t('residentialAddressSublabel'),
        },
        cadastre: {
          mask: {
            mask: '0000/000/0000/00/00',
            lazy: false,
            placeholderChar: '-',
          },
        },
      },
    },
  }
})

defaults.set('properties', ctx => {
  return {
    key: 'properties',
    label: ctx.$t('residentialProperties'),
    placement: ['residential:basis', 'residential-template:basis', 'residential-update:basis'],
    component: [
      {
        label: ctx.$t('residentialProperties'),
        key: 'properties',
        component: 'Slot',
      },
    ],

    options: {
      collapsible: true,
      expanded: true,
      size: 2,
      layout: 'properties',
      props: {
        _parent: {
          sublabel: ctx.$t('residentialSublabelProperties'),
        },
      },
    },
  }
})

defaults.set('facilities', ctx => {
  return {
    key: 'facilities',
    label: ctx.$tc('facility', 2),
    placement: ['residential:basis', 'residential-template:basis', 'residential-update:basis'],
    component: [
      {
        key: 'facilities',
        label: ctx.$tc('facility', 2),
        component: 'Slot',
      },
    ],
    options: {
      collapsible: true,
      size: 2,
      layout: 'facilities',
      props: {
        _parent: {
          sublabel: ctx.$t('residentialSublabelFacilities'),
        },
      },
    },
  }
})

//placemnet : residential:presentation
defaults.set('presentation-presentation', ctx => {
  return {
    key: 'presentation-presentation',
    label: ctx.$t('presentation'),
    placement: ['residential:presentation', 'residential-template:presentation', 'residential-update:presentation'],
    component: [
      {
        key: 'media-cover',
        dataKey: 'media',
        label: ctx.$t('cover'),
        component: [
          {
            component: 'MediaMultiple',
            key: 'cover',
            label: ctx.$t('imagesAndVideosForX', { x: ctx.$t('cover').toLowerCase() }),
          },
        ],
        options: {
          layout: 'cover',
          collapsible: true,
          expanded: true,
          props: {
            _parent: {
              sublabel: ctx.$t('residentialCoverSubtitle'),
            },
            cover: {
              style: 'min-height: 500px;',
              size: 'contain',
            },
          },
        },
      },
      {
        key: 'description',
        label: ctx.$t('description'),
        component: 'RichText',
        options: {
          collapsible: true,
          expanded: true,
          props: {
            _parent: {
              sublabel: !ctx.type || ctx.type === 'residential' ? ctx.$t('residentialDescriptionSublabel') : '',
            },
          },
        },
      },
      {
        key: 'media-files',
        dataKey: 'media',
        label: ctx.$tc('file', 2),
        component: [
          {
            key: 'attachments',
            component: 'Files',
            label: ctx.$tc('attachment', 2),
          },
          {
            key: 'floorplan',
            component: 'Files',
            label: ctx.$tc('floorplan', 2),
          },
        ],
        options: {
          collapsible: true,
          expanded: true,
          layout: 'floorplan | attachments',
          props: {
            floorplan: {
              upload: async (file, onProgress, options = {}) => {
                if (file.type === 'application/pdf') options.convert = '/api/file/transform/png?scale=2'
                return upload(file, onProgress, options)
              },
              accept: 'image/*,.pdf',
            },
          },
        },
      },
      {
        key: 'media-gallery',
        dataKey: 'media',
        label: ctx.$t('gallery'),
        component: [
          {
            component: 'MediaMultiple',
            key: 'gallery',
            label: ctx.$t('imagesAndVideosForX', { x: ctx.$t('gallery').toLowerCase() }),
          },
        ],
        options: {
          collapsible: true,
          expanded: true,
          layout: 'gallery',

          props: {
            _parent: {
              sublabel: ctx.$t('residentialGallerySublabel'),
            },
            gallery: {
              style: 'min-height: 500px;',
              size: 'contain',
            },
          },
        },
      },
      {
        key: 'bidUrl',
        label: ctx.$t('residentialBidUrlLabel'),
        component: 'Slot',
        options: {
          collapsible: true,
          props: {
            sublabel: ctx.$t('residentialBidUrlSublabel'),
          },
        },
      },
    ],
    options: {
      condition: {
        bidUrl: {
          $and: [
            {
              DisabledFeatures: {
                $exists: true,
                $nin: 'project:bid',
              },
            },
            {
              'sale.type': 'sale',
              view: 'residential',
            },
          ],
        },
      },

      collapsible: true,
      size: 2,
      layout: 'media-cover | description | media-files | media-gallery  | bidUrl',
      props: {
        _parent: {
          sublabel: ctx.$t(`${ctx.type || 'residential'}PresentationSublabel`),
        },
      },
    },
  }
})

defaults.set('redirect-url', ctx => {
  return {
    key: 'redirect-url',
    label: ctx.$t('redirectToExternalSite'),
    placement: ['residential:devtools'],
    component: [
      {
        key: 'redirectUrl',
        label: ctx.$tc('link', 1),
        component: 'Input',
        options: {
          validation: `url`,
        },
      },
    ],
    options: {
      collapsible: true,
      size: 2,
      layout: 'redirectUrl',

      props: {
        _parent: {
          sublabel: `(${ctx.$t('optional')})`,
        },
        redirectUrl: {
          placeholder: ctx.$t('residentialRedirectUrlExample'),
          sublabel: ctx.$t('residentialRedirectUrlExplanation'),
        },
      },
    },
  }
})

export default defaults
